import { render, staticRenderFns } from "./paidOrganizationList.vue?vue&type=template&id=638d625c&"
import script from "./paidOrganizationList.vue?vue&type=script&lang=js&"
export * from "./paidOrganizationList.vue?vue&type=script&lang=js&"
import style0 from "./paidOrganizationList.vue?vue&type=style&index=0&id=638d625c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports